import { render, staticRenderFns } from "./sys_users.vue?vue&type=template&id=c5052bea"
import script from "./sys_users.vue?vue&type=script&lang=js"
export * from "./sys_users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports